// DeploymentSection.jsx
import React from "react";
import "./DeploymentSection.css";
import { motion } from "framer-motion";

const DeploymentSection = ({ options = [] }) => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.3 }}
    >
      <div className="deployment-container">
        <h2 className="section-title-deployment">DEPLOYMENT OPTIONS</h2>
        
        <div className="options-grid">
          {options.map((option, index) => (
            <motion.div
              key={index}
              className="option-item"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
            >
              {option}
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default DeploymentSection;